import { useMemo } from 'react';
import { format } from 'date-fns';
import { useLocale } from 'hooks';

function useDateFormat(value, { dateFormat = 'dd MMM yyyy', language } = {}) {
  const locale = useLocale(language);

  return useMemo(() => {
    if (value) {
      const formattedValue = format(new Date(value), dateFormat, { locale: locale });
      return formattedValue.replace(/\./g, '');
    }
    return value;
  }, [dateFormat, locale, value]);
}

export default useDateFormat;
